<template>
  <div class="flow-create-basic-wrap">

    <el-form ref="baseForm" :rules="rules" class="base-form" :model="form" label-width="100px" size="mini">
      <el-form-item label="流程名称" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="流程类型" prop="type_id">
        <el-cascader v-model="form.type_id" :options="typeList" :props="typeProps" style="width: 100%;"></el-cascader>
      </el-form-item>
      <el-form-item label="移动端">
        <el-radio v-model="form.is_h5" :label="1">支持</el-radio>
        <el-radio v-model="form.is_h5" :label="0">不支持</el-radio>
      </el-form-item>
      <el-form-item label="是否隐藏">
        <el-radio v-model="form.is_hide" :label="1">是</el-radio>
        <el-radio v-model="form.is_hide" :label="0">否</el-radio>
      </el-form-item>
      <el-form-item label="权重排序">
        <el-input v-model="form.weight"></el-input>
      </el-form-item>
      <el-form-item label="标题命名规则">
        <el-input v-model="form.title_rule"></el-input>
      </el-form-item>
      <el-form-item label="编号命名规则">
        <el-input v-model="form.serial_number_rule"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-tag :type="form.status ? 'success' : 'info'">{{form.status ? '已发布' : '未发布'}}</el-tag>
      </el-form-item>

      <el-form-item size="large">
        <el-button type="primary" size="mini" @click="saveBaseInfo()" v-if="form.id == 0">保存</el-button>
        <!-- <el-button type="primary" size="mini" @click="$parent.nextStep()" v-else>下一步</el-button> -->
      </el-form-item>
    </el-form>

  </div>
</template>

<script>

import Http from "../common/Http";

export default {
  name:"flow-create-basic",
  props: ["value"],
  data () {
    return {
      form: {},
      typeList: [],
      rules: {
        name: [
          { required: true, message: '请输入流程名称', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
        ],
        type_id: [
          { required: true, message: '请选择流程类型', trigger: 'change' },
        ]
      },
      typeProps: {
        expandTrigger: 'hover',
        value: 'id',
        label: 'name',
        emitPath: false,
      }
    }
  },
  beforeMount() {
    this.form = this.getFormData()
  },
  activated() {
    this.$refs.baseForm.clearValidate()
    this.getFlowTypeTree()
  },
  watch: {

    value: {
      handler: function(data) {
        if(data.master.cache) {
          this.form = data.master.cache.master
        } else {
          this.form = data.master
        }
      },
      deep: true
    }
  },

  methods: {

    getFormData(data) {
      return Object.assign({
        id: 0,
        name: '',
        type_id: '',
        weight: '',
        status: 0,
        is_h5: 0,
        is_hide: 0,
        title_rule: '',
        serial_number_rule: '',
      }, data)
    },

    // 保存基础信息
    saveBaseInfo() {
      let data = Object.assign({}, this.form)

      this.$refs.baseForm.validate((valid) => {
        if (valid) {

          Http.post("flow/FlowMaster/saveFlowMaster", data, res => {
            this.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
            if(res.code == 1) {
              if(data.id == 0) {
                this.$router.replace({path: '/flow/FlowCreate', query: {id: res.data.id}})
              }
              this.$parent.getFlowInfo(res.data.id)
            }
          })

        } else {
          return false;
        }
      });

    },

    // 获取流程类型树
    getFlowTypeTree() {

      Http.get("flow/FlowType/getFlowTypeTree", {id: 0}, res => {
        if(res.code == 1) {
          this.typeList = res.code == 1 ? res.data : []
        } else {
          this.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        }
      })

    },

  }
}
</script>
<style lang="scss" scoped>

@import '../common.scss';

.flow-create-basic-wrap {
  display: flex;
  margin-top: 50px;
  justify-content: center;

  .base-form {
    width: 400px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/FlowCreateBasic.vue